import PRDDashboard from '../pages/PRDDashboard';

const PRDDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'prd_dashboard',
      path: '/dashboard/prd',
      component: PRDDashboard,
      permissions: [
        'KASM',
        'KASOM',
        'KASROM',
        'KASH',
        'SAM',
        'RSM',
        'NSM-SPARTAN',
        'admin',
        'COO',
        'EXECUTIVE',
      ],
    },
  ],
};

export default PRDDashboardRoute;
